import { Popover, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px',
    borderRadius: '5px',
    width: '30px',
    marginBottom: '10px',
    '& h6': {
      whiteSpace: 'nowrap',
    },
  },
  icon: {
    marginRight: '10px',
    height: 'auto',
    maxWidth: '20px',
    width: '20px',
  },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
  title: {
    marginLeft: '10px',
    fontSize: '14px',
  },
  bold: {
    fontWeight: 700,
    margin: '0 10px',
  },
}))

interface Props {
  code: string
  description?: string
  name: string
  icon_primary?: {
    url: string
  }
  icon_secondary?: {
    url: string
  }
  showTitle?: boolean
}

function Attribute({
  code,
  description,
  name,
  icon_primary,
  icon_secondary,
  showTitle,
}: Props): JSX.Element {
  const classes = useStyles({})
  const primaryIcon = icon_primary?.url
  const secondaryIcon = icon_secondary?.url
  const imageUrl = showTitle ? secondaryIcon : primaryIcon
  const [anchorEl, setAnchorEl] = React.useState<HTMLSpanElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLSpanElement>) => {
    setAnchorEl(event.currentTarget as HTMLSpanElement)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const containerFunc = () => anchorEl
  return (
    <>
      <span
        className={classes.root}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        aria-describedby="mouse-over-popover"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <img
          height={25}
          width={25}
          src={imageUrl || '/svg/like.svg'}
          alt={`${name} feature`}
          className={classes.icon}
        />
        {showTitle && (
          <>
            <Typography variant="subtitle2" className={classes.bold}>
              {code?.toLocaleUpperCase()}
            </Typography>
            <Typography variant="subtitle2">{name}</Typography>
          </>
        )}
      </span>
      {!showTitle && (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus={true}
          transitionDuration={400}
          container={containerFunc}
        >
          <Typography>{description}</Typography>
        </Popover>
      )}
    </>
  )
}

export default Attribute
